import { enviarFormatDateView, formatDateTime, formatDateTimeView, formatDateView } from '@/utils/date-fns'
import './scss/style.scss'

export default {
   name: 'SlideFuncionarios',

   created() {
      this.itemService = this.items
   },
   data() {
      return {
         form: {
            pagina: 1,
            limite: 1,
            ordenar: 'nome'
         },
         selectedItem: null,
         filteredItems: null
      }
   },
   itemService: null,

   props: {
      items: null,
      possuiPaginaAnterior: null,
      possuiProximaPagina: null,
      loading: null
   },

   methods: {
      formatDateTime(date) {
         return enviarFormatDateView(date)
      },
      viewFormatDateTime(date) {
         return formatDateView(date)
      },
      proximo() {
         if (this.possuiProximaPagina) {
            this.$emit('proximo')
         }
      },

      anterior() {
         if (this.possuiPaginaAnterior) {
            this.$emit('anterior')
         }
      }
   }
}
